module.exports = __webpack_public_path__ + "static/media/FENGYUN 2G.1a02ed80.czml";